import { useEffect } from 'react';
import { applySiteTheme } from '../lib/siteTheme';

export function useSiteTheme(settings) {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  useEffect(() => {
    applySiteTheme(settings?.theme);
  }, [settings]);

  useEffect(() => {
    const logoText = settings?.header?.logo_text || 'AICHIN';
    const logoTagline = settings?.header?.logo_tagline || 'GROUP';
    document.title = `${logoText} ${logoTagline}`.trim();
  }, [settings]);
}
